
































































































































































































































import ListOfSpeciesByFaunisticGroupTable
  from '@/components/pages/valorizations/internal/observatory/fauna/table/ListOfSpeciesByFaunisticGroupTable.vue';
import NecessaryRequestsTable
  from '@/components/pages/valorizations/internal/observatory/fauna/table/NecessaryRequestsTable.vue';
import AnnualCumulativeNumberChart
  from '@/components/pages/valorizations/internal/observatory/fauna/chart/AnnualCumulativeNumberChart.vue';
import StatusOfThreatChart
  from '@/components/pages/valorizations/internal/observatory/fauna/chart/StatusOfThreatChart.vue';

import PatrimonialFloraBalanceTable
  from '@/components/pages/valorizations/internal/observatory/flora/table/PatrimonialFloraBalanceTable.vue';
import ThreatModesChart from '@/components/pages/valorizations/internal/observatory/flora/chart/ThreatModesChart.vue';

import EvolutionOfFloristicKnowledgeChart
  from '@/components/pages/valorizations/internal/observatory/flora/chart/EvolutionOfFloristicKnowledgeChart.vue';

import NumberOfGeoLocalizedObservationsChart
  from '@/components/pages/valorizations/internal/observatory/flora/chart/NumberOfGeoLocalizedObservationsChart.vue';

import PatrimonialSheetOneSheet
  from '@/components/pages/valorizations/internal/observatory/flora/sheet/PatrimonialSheetOneSheet.vue';

import PatrimonialSheetTwoSheet
  from '@/components/pages/valorizations/internal/observatory/flora/sheet/PatrimonialSheetTwoSheet.vue';

import {Component, Watch} from 'vue-property-decorator';

import Selected from '@/models/valorization/filter/Selected';
import BasePageView from '@/views/BasePageView.vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import Filter from '@/models/valorization/filter/Filter';
import Overlay from '@/models/Overlay';
import ApiResponseOld from '@/interfaces/ApiResponseOld';
import Alert from '@/models/Alert';
import {AlertTypes} from '@/models/AlertTypes';
import {getAffairs} from '@/repositories/api/AffairApiRepository';
import Station from '@/models/Station';
import Affair from '@/models/Affair';
import moment from 'moment';

@Component({
  components: {
    BaseLayout,
    ListOfSpeciesByFaunisticGroupTable,
    NecessaryRequestsTable,
    AnnualCumulativeNumberChart,
    StatusOfThreatChart,

    PatrimonialFloraBalanceTable,
    ThreatModesChart,
    EvolutionOfFloristicKnowledgeChart,
    NumberOfGeoLocalizedObservationsChart,
    PatrimonialSheetOneSheet,
    PatrimonialSheetTwoSheet,
  }
})
export default class InternalValorizationView extends BasePageView {
  protected overlay = new Overlay();
  protected alert = new Alert();
  protected componentKey: number = 0;
  protected emptySelected = new Selected();
  protected ranges: { text: string, action: Function }[] = [];
  protected range = null;
  protected showRangeDialog = false;

  protected selected: Selected = new Selected();
  get getSelected(): Selected{
    return this.selected;
  }
  protected vm: any = this;
  protected filter = new Filter();

  @Watch('range')
  onRangeChanged(value: any) {
    if (value) {
      (value as { text: string, action: Function }).action();
    }
  }

  get isGroupsValid() {
    return (null !== this.selected.groups) || (null !== this.selected.protocol && this.selected.protocol.groups.length === 0);
  }

  get isStationValid() {
    return null !== this.selected.station;
  }

  get isProtocolValid() {
    return null !== this.selected.protocol;
  }

  get isValorizationValid() {
    return null !== this.selected.valorization;
  }

  get isDatesValid() {
    return this.selected.dates && this.selected.dates.length === 2;
  }

  get isAllValid() {
    return this.isStationValid && this.isProtocolValid && this.isValorizationValid && this.isDatesValid && this.isGroupsValid;
  }

  reset() {
    this.selected = new Selected();
  }

  toggleGroups() {
    this.$nextTick(() => {
      if (this.selected.protocol) {
        if (this.selected.groups && this.selected.groups.length > 0) {
          this.selected.groups = [];
        } else {
          this.selected.groups = this.selected.protocol.groups;
        }
      } else {
        this.selected.groups = [];
      }
    });
  }

  async fetStations() {
    this.overlay.text = 'Recherche en cours...';
    this.overlay.show = true;

    let response: ApiResponseOld | null = null;

    try {
      response = await getAffairs();
    } catch (e) {
      this.alert = new Alert(e.toString(), AlertTypes.Error, true);
    }

    if (null !== response && response.error === 'success') {
      const affairs = response.data as Affair[];


      let stations: Station[] = [];

      if (Array.isArray(affairs)) {
        affairs.forEach(affair => {
          let station = stations.find(station => station.id === affair.station);

          if (!station) {
            station = new Station(
              affair.station,
              affair.station === '' ? 'Sans station' : affair.station,
              [affair]
            );

            stations.push(station);
          } else {
            station.affairs.push(affair);
          }
        });
      }

      this.filter.stations = stations;
    }

    this.overlay.show = false;
  }

  init() {
    this.ranges = [
      {
        text: `Aujourd'hui`,
        action: () => {
          this.selected.dates = [
            moment().format('YYYY-DD-MM'),
            moment().format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Hier',
        action: () => {
          this.selected.dates = [
            moment().subtract(1, 'days').format('YYYY-DD-MM'),
            moment().subtract(1, 'days').format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Les 7 derniers jours',
        action: () => {
          this.selected.dates = [
            moment().subtract(6, 'days').format('YYYY-DD-MM'),
            moment().format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Les 30 derniers jours',
        action: () => {
          this.selected.dates = [
            moment().subtract(29, 'days').format('YYYY-DD-MM'),
            moment().format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Ce mois-ci',
        action: () => {
          this.selected.dates = [
            moment().startOf('month').format('YYYY-DD-MM'),
            moment().endOf('month').format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Le mois dernier',
        action: () => {
          this.selected.dates = [
            moment().subtract(1, 'month').format('YYYY-DD-MM'),
            moment().subtract(1, 'month').format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Données de l\'année',
        action: () => {
          this.selected.dates = [
            moment().startOf('year').format('YYYY-DD-MM'),
            moment().endOf('year').format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Données de toutes les années des stations',
        action: () => {
          this.selected.dates = [
            moment().subtract(100, 'year').format('YYYY-DD-MM'),
            moment().subtract(-100, 'year').format('YYYY-DD-MM'),
          ];
        }
      },
      {
        text: 'Entre 2 dates',
        action: () => {
          this.showRangeDialog = true;
        }
      },
    ];
  }

  created() {
    this.init();
  }

  mounted() {
    this.fetStations();
  }
}
